export default "__VITE_ASSET__Kkhzak6W__"